(function () {
  "use strict";

  /* Product handle → language label (DRAFT survival guides) */
  var META = {
    "hausa-survival-cultural-connection-guide": { lang: "Hausa", type: "Survival Guide" },
    "swahili-survival-cultural-connection-guide": { lang: "Swahili", type: "Survival Guide" },
    "yoruba-survival-cultural-connection-guide": { lang: "Yoruba", type: "Survival Guide" },
    "igbo-survival-cultural-connection-guide": { lang: "Igbo", type: "Survival Guide" },
    "chichewa-survival-cultural-connection-guide": { lang: "Chichewa", type: "Survival Guide" },
    "icibemba-bemba-survival-cultural-connection-guide": { lang: "Icibemba / Bemba", type: "Survival Guide" },
    "somali-survival-cultural-connection-guide": { lang: "Somali", type: "Survival Guide" },
    "wolof-survival-cultural-connection-guide": { lang: "Wolof", type: "Survival Guide" },
    "setswana-survival-cultural-connection-guide": { lang: "Setswana", type: "Survival Guide" },
    "siswati-survival-cultural-connection-guide": { lang: "siSwati", type: "Survival Guide" },
    "lamba-survival-cultural-connection-guide": { lang: "Lamba", type: "Survival Guide" },
    "kaonde-survival-cultural-connection-guide": { lang: "Kaonde", type: "Survival Guide" },
    "lunda-survival-cultural-connection-guide": { lang: "Lunda", type: "Survival Guide" }
  };

  function enhanceProductCards() {
    document.querySelectorAll(".card-wrapper, .product-card-wrapper").forEach(function (card) {
      if (card.querySelector(".ut-pub-card-badges")) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute("href").match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var info = META[m[1]];
      if (!info) return;
      var wrap = document.createElement("div");
      wrap.className = "ut-pub-card-badges";
      wrap.innerHTML =
        '<span class="ut-pub-badge ut-pub-badge--lang">' + info.lang + "</span>" +
        '<span class="ut-pub-badge">' + info.type + "</span>" +
        '<span class="ut-pub-badge ut-pub-badge--dl">Digital Download</span>';
      var heading = card.querySelector(".card__information") || card.querySelector(".card__content");
      if (heading) heading.insertBefore(wrap, heading.firstChild);
    });
  }

  function parallaxHero() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var img = document.querySelector(".banner__media img, .banner .media img");
    if (!img) return;
    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight) {
            img.style.transform = "translate3d(0," + y * 0.25 + "px,0) scale(1.05)";
          }
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function revealOnScroll() {
    var els = document.querySelectorAll(".ut-pub-reveal, .ut-pub-section, .shopify-section");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach(function (el) {
      if (!el.classList.contains("ut-pub-reveal")) el.classList.add("ut-pub-reveal");
      io.observe(el);
    });
  }

  function init() {
    enhanceProductCards();
    parallaxHero();
    revealOnScroll();
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href").slice(1);
        var t = document.getElementById(id);
        if (t) {
          e.preventDefault();
          t.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    enhanceProductCards();
  });
})();
